import { GQL_PaycheckLineCalculationTypeEnum, GQL_MainPaycheckLineTemplateSave } from '@/queries/global';
import { GQL_allMainPaycheckLineTemplates_mainPaycheckLineTemplates } from '@/queries/__generated__/allMainPaycheckLineTemplates';
import Decimal from '@/utils/decimal';

export const newMainPaycheckLineTemplateObject: (() => GQL_MainPaycheckLineTemplateSave) = () => {
  return {
    active: true,
    altinnDescription: null,
    altinnFordel: null,
    calculatePositive: true,
    calculationType: GQL_PaycheckLineCalculationTypeEnum.CASHEDOUT,
    carId: null,
    carOverwrite: false,
    departmentId: null,
    departmentOverwrite: false,
    description: '',
    employerTaxable: false,
    includeInVacationMoneyBase: false,
    number: 0,
    taxDeduction: false,
    taxDeductionVoluntary: false,
    projectId: null,
    projectOverwrite: false,
    quantity: new Decimal(0),
    rate: new Decimal(0),
    sum: new Decimal(0),
    taxable: false,
    vacationMoneyEarnedInPreviousYear: false,
    vacationMoneyEarnedInCurrentYear: false,
  };
};

export const convertToMainPaycheckLineTemplateSave: ((data: GQL_allMainPaycheckLineTemplates_mainPaycheckLineTemplates[]) => GQL_MainPaycheckLineTemplateSave[]) = (data: GQL_allMainPaycheckLineTemplates_mainPaycheckLineTemplates[]) => {
  return data.map((template: GQL_allMainPaycheckLineTemplates_mainPaycheckLineTemplates) => {
    return {
      ...template,
      car: undefined,
      carId: template.car ? template.car.id : null,
      project: undefined,
      projectId: template.project ? template.project.id : null,
      department: undefined,
      departmentId: template.department ? template.department.id : null,
    };
  });
};
